import React, { Component, Fragment, createRef } from "react";
import { BsMicMuteFill, BsMicFill } from "react-icons/bs"; //BsFillCameraVideoFill, BsFillCameraVideoOffFill
import { OpenVidu } from "openvidu-browser";
import { MdCallEnd, MdCheck } from "react-icons/md";
import appToast from "./app-toast";
import AppConfirmationModal from "components/app-confirmation-modal";
import CONSTANSTS from "common/constansts";

class AppOpenViduVideo extends Component {
  constructor(props) {
    super(props);
    this.videoRef = createRef();
  }

  componentDidUpdate(props) {
    if (props && !!this.videoRef) {
      this.props.streamManager.addVideoElement(this.videoRef.current);
    }
  }

  componentDidMount() {
    if (this.props && !!this.videoRef) {
      this.props.streamManager.addVideoElement(this.videoRef.current);
    }
  }

  render() {
    return <video style={this.props.style} ref={this.videoRef} autoPlay={true} />;
  }
}

class AppOpenVidu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      myUserName: this.props.myUserName,
      session: undefined,
      publisher: undefined,
      subscribers: [],

      sessionName: this.props.sessionName,
      token: "",

      liveStart: "",
      connectAudio: true,
     connectVideo: false,

      // recordingConfirmation: false,
      stopStreamConfirmation: false,
      completeMeetingConfirmation: false,
    };

    this.joinSession = this.joinSession.bind(this);
    this.joinSessionGetWss = this.joinSessionGetWss.bind(this);
    this.leaveSession = this.leaveSession.bind(this);
    this.checkPermissions = this.checkPermissions.bind(this);

    this.publishAudio = this.publishAudio.bind(this);
    this.publishVideo = this.publishVideo.bind(this);
    this.OV = new OpenVidu();
  }

  componentDidUpdate() {}

  deleteSubscriber(streamManager) {
    let subscribers = this.state.subscribers;
    let index = subscribers.indexOf(streamManager, 0);
    if (index > -1) {
      subscribers.splice(index, 1);
      this.setState({
        subscribers: subscribers,
      });
    }
  }

  joinSession() {
    this.checkPermissions();
    // fetch(
    //   // "http://49.0.203.50/ivc-app/meeting/api/v1/isRecordingExisted/" +
    //   process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.IS_RECORDING_EXISTED + this.state.sessionName,
    //   {
    //     methid: "GET",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Accept: "*/*",
    //       "Accept-Encoding": "gzip, deflate, br",
    //       Connection: "keep-alive",
    //       "Accept-language": "en", "X-DEVICE-OS": "Web",
    //       Authorization: "Bearer " + localStorage.getItem("@storage_token"),
    //     },
    //   }
    // )
    //   .then((response) => response.json())
    //   .then((responseJson) => {
    //     if (responseJson.responseCode === 200) {
    //       if (responseJson.result) {
    //         this.setState({
    //           recordingConfirmation: true,
    //         });
    //       } else {
    //         this.checkPermissions();
    //       }
    //     } else {
    //       appToast(responseJson.message, false);
    //     }
    //   });
  }

  checkPermissions() {
    // this.joinSessionGetWss();
    const permissions = navigator.mediaDevices.getUserMedia({audio: true, video: false})
    permissions.then((stream) => {
        console.log("Stream =>", stream);
        this.joinSessionGetWss();
    })
    .catch((err) => {
        appToast(`${err.name} : ${err.message}`, false);
      console.log(`${err.name} : ${err.message}`);
    });
  }

  checkIsCorrupted = () => {
    console.log("Call Recording");
          fetch(
            // "http://49.0.203.50/ivc-app/meeting/api/v1/join/" +
            process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.CHECK_LOAN_MEETING_RECORDING_IS_CORRUPTED + this.state.sessionName,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
                "Accept-Encoding": "gzip, deflate, br",
                Connection: "keep-alive",
                "Accept-language": "en", "X-DEVICE-OS": "Web",
                Authorization: "Bearer " + localStorage.getItem("@storage_token"),
              },
            }
          ) .then((response) => response.json())
          .then((responseJson) => {
            console.log(responseJson.result);
            if (responseJson.result === true) {
                const mySession = this.state.session;
                if (mySession) {
                  mySession.disconnect();
                }
                this.OV = null;
                this.setState({
                  myUserName: this.props.myUserName,
                  session: undefined,
                  publisher: undefined,
                  subscribers: [],
                  token: "",
                  liveStart: "",
                  connectAudio: true,
                 connectVideo: false,
                });
                appToast("Loan Meeting Corrupted, Please rejoin the meeting !", false);
             }
             else if(responseJson.result === false)
             {
              null
             }
             else{
              setTimeout(this.checkIsCorrupted, 5000);
             }
    });
  }

  joinSessionGetWss() {

    console.log("test 1");

    // this.setState({
    //   recordingConfirmation: false,
    // });
    this.setState({ liveStart: "starting" });


    console.log("test 2");

    fetch(
      // "http://49.0.203.50/ivc-app/meeting/api/v1/join/" +
      process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.JOIN_SESSION + this.state.sessionName,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-Encoding": "gzip, deflate, br",
          Connection: "keep-alive",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + localStorage.getItem("@storage_token"),
        },
      }
    )
      .then((response) => response.json())
      .then((responseJson) => {

        console.log("test 3");

        if (responseJson.responseCode && responseJson.responseCode !== 200) {
          this.setState({ liveStart: "" });
          appToast(responseJson.message, false);
        } else {
          this.checkIsCorrupted();
          console.log("test 4");
          if (responseJson.result) {
            let openViduToken = responseJson.result;

            console.log(openViduToken);

            this.setState({ token: openViduToken });

            this.props.updateDisableSave(true);

            this.OV = new OpenVidu();
            this.setState(
              {
                session: this.OV.initSession(),
              },
              () => {
                var mySession = this.state.session;
                mySession.on("streamCreated", (event) => {
                  var subscriber = mySession.subscribe(event.stream, undefined);
                  var subscribers = this.state.subscribers;
                  subscribers.push(subscriber);

                  this.setState({
                    subscribers: subscribers,
                  });
                });

                mySession.on("streamDestroyed", (event) => {
                  this.deleteSubscriber(event.stream.streamManager);
                });

                mySession.on("exception", (exception) => {
                  // console.warn(exception);
                  appToast(exception, false);
                });
                mySession
                  .connect(openViduToken, {
                    clientData: this.state.myUserName,
                  })
                  .then(() => {
                    let publisher = this.OV.initPublisher(undefined, {
                      audioSource: undefined, // The source of audio. If undefined default microphone
                      videoSource: false, // The source of video. If undefined default webcam
                      publishAudio: true, // Whether you want to start publishing with your audio unmuted or not
                     publishVideo: false, // Whether you want to start publishing with your video enabled or not
                      resolution: "1366x768", // The resolution of your video
                      frameRate: 30, // The frame rate of your video
                      insertMode: "APPEND", // How the video is inserted in the target element 'video-container'
                      mirror: false, // Whether to mirror your local video or not
                    });

                    mySession.publish(publisher).then(() => {
                      this.setState({
                        publisher: publisher,
                      })
                      this.setState({ liveStart: "started" });
                    });
                  })
                  .catch((error) => {
                    appToast(`There was an error connecting to the session: ${error.code}, ${error.message}`, false);
                    this.setState({ liveStart: "" });
                  });
              }
            );
          } else {
            this.setState({ liveStart: "" });
          }
        }
      });
  }

  leaveSession(isCompleted) {
    let payload = {
      sessionName: this.state.sessionName,
      token: this.state.token,
      isCompleted,
      isInterview: this.props.buttonTitle == "Meeting", // "Meeting" is Kyc Interview, "Briefing" is Live Briefing
    };
    fetch(
      // "http://49.0.203.50/ivc-app/meeting/api/v1/leave", {
      process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.LEAVE_SESSION,
      {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Accept-Encoding": "gzip, deflate, br",
          Connection: "keep-alive",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + localStorage.getItem("@storage_token"),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    )
      .then((response) => response.json())
      .then((jsonResponse) => {
        if (jsonResponse.responseCode && jsonResponse.responseCode !== 200) {
          appToast(jsonResponse.message, false);
          this.setState({ liveStart: "started" });
        } else {
          const mySession = this.state.session;

          if (mySession) {
            mySession.disconnect();
          }
          this.OV = null;
          this.setState({
            myUserName: this.props.myUserName,
            session: undefined,
            publisher: undefined,
            subscribers: [],

            sessionName: this.props.sessionName,
            token: "",

            liveStart: "",
            connectAudio: true,
           connectVideo: false,
          });
          window.location.reload();
        }
      });
  }

  publishAudio() {
    this.setState((prevState) => ({
      connectAudio: !prevState.connectAudio,
    }));
    this.state.publisher.publishAudio(!this.state.connectAudio);
  }

  publishVideo() {
    this.setState((prevState) => ({
      connectVideo: !prevState.connectVideo,
    }));
    this.state.publisher.publishVideo(this.state.connectVideo);
  }

  

  render() {
    return (
      <Fragment>
        {/* <AppConfirmationModal
          label="Starting this meeting will overwrite the previous recording."
          isOpen={this.state.recordingConfirmation}
          noOnClick={() => this.setState({ recordingConfirmation: false })}
          confirmOnClick={() => this.checkPermissions()}
        /> */}

        <AppConfirmationModal
          label="Are you sure you want to mark this interview as complete?"
          isOpen={this.state.completeMeetingConfirmation}
          noOnClick={() => this.setState({ completeMeetingConfirmation: false })}
          confirmOnClick = {() => this.leaveSession(true)}
        />

        <AppConfirmationModal
          label="This action is not consider as a complete interview. Are you sure?"
          isOpen={this.state.stopStreamConfirmation}
          noOnClick={() => this.setState({ stopStreamConfirmation: false })}
          confirmOnClick = {() => this.leaveSession(false)}
        />

        {this.state.session !== undefined && this.state.liveStart === "started" ? (
          <div className="open-vidu__wrapper">
            <div className="open-vidu__video-content">
              {this.state.subscribers.length ? (
                <div>
                  <AppOpenViduVideo
                    streamManager={this.state.subscribers[0]}
                    style={{
                      borderRadius: 6,
                      width: 640,
                      height: 360,
                      marginBottom: -7,
                    }}
                  />
                </div>
              ) : null}
              <div className="open-vidu__buttons-wrapper">
                <button className="open-vidu__button open-vidu__button--transparent" onClick={() => this.publishAudio()}>
                  {this.state.connectAudio ? <BsMicFill color="#ffffff" /> : <BsMicMuteFill color="#ffffff" />}
                </button>
                {/* <button className="open-vidu__button open-vidu__button--transparent" onClick={() => this.publishVideo()}>
                  {this.state.connectVideo ? <BsFillCameraVideoOffFill color="#ffffff" /> : <BsFillCameraVideoFill color="#ffffff" />}
                </button> */}
                <button className="open-vidu__button open-vidu__button--green" onClick={() => {
                    this.setState({completeMeetingConfirmation: true})
                  }}>
                  <MdCheck color="#ffffff" />
                </button>
                <button
                  className="open-vidu__button  open-vidu__button--red"
                  onClick={() => {
                    this.setState({stopStreamConfirmation: true})
                  }}
                >
                  <MdCallEnd color="#ffffff" />
                </button>
              </div>
            </div>

            <div className="open-vidu__video-row">
              {this.state.publisher !== undefined ? (
                <div className="open-vidu__video-mini">
                  <AppOpenViduVideo
                    streamManager={this.state.publisher}
                    style={{
                      borderRadius: 6,
                      width: 142,
                      height: 80,
                    }}
                  />
                </div>
              ) : null}
            </div>
          </div>
        ) : this.state.liveStart === "ended" ? (
          <div className="open-vidu__end">{this.props.buttonTitle} Ended</div>
        ) : (
          <button
            className="open-vidu__button-join"
            disabled={this.state.liveStart === "starting" ? true : false}
            onClick={() => {
              this.joinSession();
            }}
          >
            {this.state.liveStart === "starting" ? `Joining ${this.props.buttonTitle} ...` : `Join ${this.props.buttonTitle}`}
          </button>
        )}
      </Fragment>
    );
  }
}

export default AppOpenVidu;
